var _regeneratorRuntime = require("/codebuild/output/src2234831700/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/regenerator/index.js");
var _defineProperty = require("/codebuild/output/src2234831700/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/defineProperty.js");
var _asyncToGenerator = require("/codebuild/output/src2234831700/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var currentScopes = require('./currentScopes.js');
var exports$1 = require('./exports.js');
var semanticAttributes = require('./semanticAttributes.js');
require('./tracing/errors.js');
var object = require('./utils-hoist/object.js');
require('./debug-build.js');
require('./utils-hoist/logger.js');
require('./utils-hoist/time.js');
require('./utils-hoist/debug-build.js');
var normalize = require('./utils-hoist/normalize.js');
require('./utils-hoist/syncpromise.js');
var trace = require('./tracing/trace.js');
var trpcCaptureContext = {
  mechanism: {
    handled: false,
    data: {
      function: 'trpcMiddleware'
    }
  }
};
function captureIfError(nextResult) {
  // TODO: Set span status based on what TRPCError was encountered
  if (typeof nextResult === 'object' && nextResult !== null && 'ok' in nextResult && !nextResult.ok && 'error' in nextResult) {
    exports$1.captureException(nextResult.error, trpcCaptureContext);
  }
}

/**
 * Sentry tRPC middleware that captures errors and creates spans for tRPC procedures.
 */
function trpcMiddleware() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(opts) {
      var _clientOptions$normal;
      var path, type, next, rawInput, getRawInput, client, clientOptions, trpcContext, rawRes;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            path = opts.path, type = opts.type, next = opts.next, rawInput = opts.rawInput, getRawInput = opts.getRawInput;
            client = currentScopes.getClient();
            clientOptions = client === null || client === void 0 ? void 0 : client.getOptions();
            trpcContext = {
              procedure_path: path,
              procedure_type: type
            };
            object.addNonEnumerableProperty(trpcContext, '__sentry_override_normalization_depth__', 1 + (// 1 for context.input + the normal normalization depth
            (_clientOptions$normal = clientOptions === null || clientOptions === void 0 ? void 0 : clientOptions.normalizeDepth) !== null && _clientOptions$normal !== void 0 ? _clientOptions$normal : 5) // 5 is a sane depth
            );
            if (!(options.attachRpcInput !== undefined ? options.attachRpcInput : clientOptions === null || clientOptions === void 0 ? void 0 : clientOptions.sendDefaultPii)) {
              _context2.next = 17;
              break;
            }
            if (rawInput !== undefined) {
              trpcContext.input = normalize.normalize(rawInput);
            }
            if (!(getRawInput !== undefined && typeof getRawInput === 'function')) {
              _context2.next = 17;
              break;
            }
            _context2.prev = 8;
            _context2.next = 11;
            return getRawInput();
          case 11:
            rawRes = _context2.sent;
            trpcContext.input = normalize.normalize(rawRes);
            _context2.next = 17;
            break;
          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](8);
          case 17:
            return _context2.abrupt("return", currentScopes.withScope(function (scope) {
              scope.setContext('trpc', trpcContext);
              return trace.startSpanManual({
                name: "trpc/".concat(path),
                op: 'rpc.server',
                attributes: _defineProperty(_defineProperty({}, semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, 'route'), semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.rpc.trpc'),
                forceTransaction: !!options.forceTransaction
              }, /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(span) {
                  var nextResult;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return next();
                      case 3:
                        nextResult = _context.sent;
                        captureIfError(nextResult);
                        span.end();
                        return _context.abrupt("return", nextResult);
                      case 9:
                        _context.prev = 9;
                        _context.t0 = _context["catch"](0);
                        exports$1.captureException(_context.t0, trpcCaptureContext);
                        span.end();
                        throw _context.t0;
                      case 14:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee, null, [[0, 9]]);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            }));
          case 18:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[8, 15]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
exports.trpcMiddleware = trpcMiddleware;